import { createFileRoute, redirect } from '@tanstack/react-router';

import { z } from 'zod';

export const Route = createFileRoute('/_secured/reporting/data-exploration/')({
  validateSearch: z.object({
    view: z.string().optional(),
  }),
  async beforeLoad({ context }) {
    const flagsmith = await context.getInstance('flagsmith', '@mint/arm');
    const guardsContext = await context.getGuardContext(flagsmith);

    // Redirect to /reporting/dashboards when reportingMint2 flag is enabled
    if (guardsContext.flagsService?.hasFeature('reportingMint2')) {
      throw redirect({
        to: '/reporting/dashboards',
      });
    }
  },
  loader: async ({ context }) => {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    await context.getInstance('i18n', '@myn/pivot');
    // TODO: dependencies problem
    // await checkIfUserHasCampaignsAndViewLoader(queryClientPivot);

    const title = i18n.t('Data Exploration | MINT');
    return { title };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
});
